import React from "react";
import styled from "styled-components";
import Sidebar from "./Sidebar";
import IncidentsTable from "./IncidentsTable";

const Dashboard = () => {
  return (
    <DashboardContainer>
      <Sidebar />
      <MainContent>
        <h2>Incidencias - Estado: Nuevo</h2>
        <IncidentsTable />
      </MainContent>
    </DashboardContainer>
  );
};

const DashboardContainer = styled.div`
  display: flex;
  height: 100vh;
`;

const MainContent = styled.div`
  flex: 1;
  padding: 20px;
  background-color: #f8f9fa;
  margin-left: 200px;
  transition: margin-left 0.3s ease;

  @media (max-width: 768px) {
    margin-left: 0; /* Asegúrate de que ocupe el ancho completo */
  }
`;


export default Dashboard;
